import axios from "axios";

export const getUser = async () => {
    try {
        const res = await axios.get('/uk/current-user',
            { withCredentials: true }
        )

        return res.data;
    }
    catch (e) {
        return null
    }

}
